import { Component, Input } from '@angular/core';
import {faInfoCircle as fasInfoCircle} from '@fortawesome/free-solid-svg-icons'

export interface Sidekick{
	metric: 'string';
	color: ['red' , 'green' , 'gray'];
}
/**
 *
 */
@Component({
  selector: 'crem-metric',
  template: `<mat-card class="costar-hero-metric-card">
	<mat-card-header>
		<mat-card-title>{{title}}</mat-card-title>
		<div class="addl-info-wrapper">
			<dx-button icon="fas fa-info-circle" (click)="toggleTooltip()" [id]="popoverId" ></dx-button>
    </div>
	</mat-card-header>
	<mat-card-content>
		<div class="hero-value">
			{{heroMetric}}
		</div>
		<div class="sidekick-value-wrapper" *ngIf="sidekickMetric">
			<div class="sidekick-value" [ngClass]="sidekickColor" >{{sidekickMetric}}</div>
			<!-- <div class="sidekick-value" *ngIf="sidekickMetricB">{{sidekickMetricB}}</div> -->
		</div>
	</mat-card-content>
	<mat-card-footer>
		<mat-card-subtitle>
			{{subtitle}}
		</mat-card-subtitle>
	</mat-card-footer>
</mat-card>
<dx-popover
    [target]="popoverTarget"
    position="bottom"
    [width]="400"
    [(visible)]="popoverVisible">
    <div *dxTemplate="let data = model of 'content'" class="hero-tooltip">
        {{tooltip}}
    </div>
</dx-popover>`,
styleUrls: ['hero-metric.component.scss']
})
export class HeroMetricComponent {
  @Input() title:string;
  @Input() subtitle: string;
  @Input() heroMetric: string;
  @Input() sidekickMetric: string;
  @Input() sidekickColor: string;
  @Input() tooltip: string;
  @Input() popoverId: string;
  popoverVisible : Boolean = false;
  popoverTarget: string;
  fasInfoCircle = fasInfoCircle
  constructor() {

    }

    ngOnInit(){
      this.popoverId = "hero" + this.title.replace(/\s/g, '');
      this.popoverTarget = "#" + this.popoverId;
    }
    toggleTooltip() {
      this.popoverVisible = !this.popoverVisible;
  }
}
